import type { FC, PropsWithChildren, ReactElement } from 'react'

import { Container } from '@skytech/ui/Container'
import { useNavigate } from 'react-router-dom'

import { APP_ROUTES } from '@/util/app-routes'

import './MenuSubPagesLayout.styles.scss'

export const MenuSubPagesLayout: FC<PropsWithChildren<{ title: string | ReactElement }>> = ({
  children,
  title,
}) => {
  const navigate = useNavigate()

  return (
    <Container onSwipedLeft={() => navigate(APP_ROUTES.HOME)} className="mobile-sub-menu">
      <Container.Header>{title}</Container.Header>

      {children}
    </Container>
  )
}
